import { render, staticRenderFns } from "./ MtrPageTable.vue?vue&type=template&id=25b0bb96&scoped=true"
import script from "./ MtrPageTable.vue?vue&type=script&lang=js"
export * from "./ MtrPageTable.vue?vue&type=script&lang=js"
import style0 from "./ MtrPageTable.vue?vue&type=style&index=0&id=25b0bb96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b0bb96",
  null
  
)

export default component.exports